export default __webpack_public_path__ + "a0c02be98e31a6e23315fb74b1bca3d7.svg";